var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3214_1983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60359 10.1517H8.32846V15.5759C8.32846 16.1725 8.81663 16.6607 9.41329 16.6607H13.7526C14.3493 16.6607 14.8374 16.1725 14.8374 15.5759V10.1517H16.5623C17.5278 10.1517 18.016 8.98011 17.3325 8.29667L12.3532 3.31731C11.9301 2.89423 11.2466 2.89423 10.8236 3.31731L5.84421 8.29667C5.16077 8.98011 5.63809 10.1517 6.60359 10.1517ZM4 19.9152C4 20.5118 4.48817 21 5.08483 21H18.1028C18.6994 21 19.1876 20.5118 19.1876 19.9152C19.1876 19.3185 18.6994 18.8303 18.1028 18.8303H5.08483C4.48817 18.8303 4 19.3185 4 19.9152Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3214_1983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.a9b06df73bfa26309069a1ea3b020e09.svg";
export { ForwardRef as ReactComponent };